import type { GuidedCriterionChipVisual } from "./assessmentCriteriaGates";
import { Paperclip } from "./icons";

/** Number always visible; complete state adds a small tick below the digit (fits inside inset selection ring). */
export function GuidedAssessmentCriterionChipContent({
  visual,
  index,
  hasAttachments = false,
}: {
  visual: GuidedCriterionChipVisual;
  index: number;
  /** Criterion has at least one document or photo in evidence */
  hasAttachments?: boolean;
}) {
  const n = index + 1;

  const body =
    visual === "complete" ? (
      <span className="flex flex-col items-center justify-center leading-none gap-px py-px">
        <span className="text-[13px] font-bold tabular-nums">{n}</span>
        <span className="text-[10px] font-bold opacity-95" aria-hidden>
          ✓
        </span>
      </span>
    ) : (
      <span className="tabular-nums">{n}</span>
    );

  if (!hasAttachments) {
    return body;
  }

  /* Two layers positioned against the circular chip (parent <button class="relative …">): number stays
   * centred in the full circle; paperclip sits top-right and nudges outward so it does not cover the digit. */
  return (
    <>
      <span className="pointer-events-none absolute inset-0 z-0 flex items-center justify-center">
        {body}
      </span>
      <span
        className="pointer-events-none absolute -top-1.5 -right-1.5 z-[2] flex h-[22px] w-[22px] items-center justify-center rounded-full border border-white/95 bg-white text-slate-600 shadow-[0_1px_3px_rgba(15,23,42,0.2)] ring-1 ring-slate-300/75 dark:bg-slate-800 dark:text-slate-200 dark:border-slate-600 dark:ring-slate-500/80"
        aria-hidden
      >
        <Paperclip className="block h-[14px] w-[14px] shrink-0" strokeWidth={1.65} aria-hidden />
      </span>
    </>
  );
}
